<template>
  <div class="analytics-chart-wrap">
    <canvas ref="chartCanvas"></canvas>
  </div>
</template>

<script>
import { Chart, registerables } from "chart.js";

Chart.register(...registerables);

export default {
  name: "HourlyTotalsChart",
  props: {
    hours: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      chartInstance: null,
    };
  },
  watch: {
    hours: {
      deep: true,
      handler() {
        this.renderChart();
      },
    },
  },
  mounted() {
    this.renderChart();
  },
  beforeUnmount() {
    this.destroyChart();
  },
  methods: {
    destroyChart() {
      if (this.chartInstance) {
        this.chartInstance.destroy();
        this.chartInstance = null;
      }
    },
    renderChart() {
      if (!this.$refs.chartCanvas) {
        return;
      }

      this.destroyChart();

      const labels = this.hours.map((item) => item.label || `${item.hour}:00`);
      const photos = this.hours.map((item) => Number(item.photos || 0));
      const revenue = this.hours.map((item) => Number(item.revenue || 0));

      this.chartInstance = new Chart(this.$refs.chartCanvas, {
        type: "bar",
        data: {
          labels,
          datasets: [
            {
              label: "Photos",
              data: photos,
              backgroundColor: "rgba(13, 110, 253, 0.6)",
              borderColor: "#0d6efd",
              borderWidth: 1,
              yAxisID: "yPhotos",
            },
            {
              label: "Revenue (GEL)",
              data: revenue,
              type: "line",
              borderColor: "#198754",
              backgroundColor: "rgba(25, 135, 84, 0.2)",
              borderWidth: 2,
              tension: 0.2,
              pointRadius: 2,
              yAxisID: "yRevenue",
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          interaction: {
            mode: "index",
            intersect: false,
          },
          plugins: {
            legend: {
              position: "top",
            },
          },
          scales: {
            x: {
              ticks: {
                maxRotation: 0,
              },
            },
            yPhotos: {
              position: "left",
              beginAtZero: true,
              title: {
                display: true,
                text: "Photos",
              },
              ticks: {
                precision: 0,
              },
            },
            yRevenue: {
              position: "right",
              beginAtZero: true,
              grid: {
                drawOnChartArea: false,
              },
              title: {
                display: true,
                text: "Revenue (GEL)",
              },
            },
          },
        },
      });
    },
  },
};
</script>

<style scoped>
.analytics-chart-wrap {
  position: relative;
  width: 100%;
  min-height: 280px;
}
</style>
